<template>
  <form v-on:submit.prevent="editBed">
    <div class="modal-card">
      <header class="modal-card-head">
        <p class="modal-card-title">Editar datos de la cama</p>
        <button type="button" class="delete" @click="$emit('close')" />
      </header>
      <section class="modal-card-body">
        <b-loading
          :is-full-page="false"
          v-model="isLoading"
          :can-cancel="true"
        ></b-loading>
        <b-table
          :data="listBedHistories"
          :narrowed="true"
          :hoverable="true"
          :loading="isLoading"
          paginated
          per-page="10"
        >
          <b-table-column
            field="ventilator_used"
            label="Ventilador ocupado"
            v-slot="props"
            searchable
          >
            {{
              props.row.ventilator_used == null
                ? "NO"
                : props.row.ventilator_used.toUpperCase()
            }}
          </b-table-column>
          <b-table-column
            field="covid19"
            label="COVID19"
            v-slot="props"
            searchable
          >
            {{ props.row.covid19 }}
          </b-table-column>
          <b-table-column
            field="user.completeName"
            label="Responsable"
            v-slot="props"
            searchable
          >
            {{ props.row.user.completeName }}
          </b-table-column>
          <b-table-column
            field="created_at"
            label="Ingreso"
            v-slot="props"
            searchable
          >
            {{ props.row.created_at }}
          </b-table-column>
          <b-table-column
            field="updated_at"
            label="Actualización"
            v-slot="props"
            searchable
          >
            {{ props.row.updated_at }}
          </b-table-column>
          <template slot="empty">
            <section class="section">
              <div class="content has-text-grey has-text-centered">
                <p>
                  <b-icon icon="frown-open" size="is-large"></b-icon>
                </p>
                <p>No hay movimientos en el listado actual</p>
              </div>
            </section>
          </template>
        </b-table>
      </section>
      <footer class="modal-card-foot">
        <button class="button" type="button" @click="$emit('close')">
          Cerrar
        </button>
        <button class="button is-primary" type="submit">Guardar</button>
      </footer>
    </div>
  </form>
</template>
<script>
import { BedHistoryFindByBedId } from '../../services/bedHistory';

export default {
  props: ["bedId"],
  data() {
    return {
      listBedHistories: [],
      isLoading: false,
    };
  },
  mounted() {
    this.chargeData();
  },
  methods: {
    async chargeData() {
      this.isLoading = true;
      let data = await BedHistoryFindByBedId(this.$http, this.bedId);
      this.listBedHistories = data.map(bedHistory => {
        return {
          ...bedHistory,
          user: {
            ...bedHistory.user,
            completeName: `${bedHistory.user.name} ${bedHistory.user.apepat}`
          }
        }
      })
      this.isLoading = false;
    },
  },
};
</script>